import * as Patient from '../constants/patient.constant'

export interface State {
  id?: string
  createdAt?: Date
  heartRate?: number
  gender: number
  birthdayYmd: Date
  hospitalIds: string[]
  username: string
  shared: {
    enable: boolean
  }
}

export const initialState: State = {
  id: null,
  createdAt: null,
  heartRate: 0,
  gender: 0,
  birthdayYmd: null,
  hospitalIds: [],
  username: '',
  shared: {
    enable: false,
  },
}

const report = (state: any = initialState, action: any) => {
  switch (action.type) {
    case Patient.GET_PATIENT_DETAILS:
      return {
        ...state,
      }
    case Patient.GET_PATIENT_DETAILS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }
    case Patient.GET_PATIENT_SHARED:
      return {
        ...state,
      }
    case Patient.GET_PATIENT_SHARED_SUCCESS:
      return {
        ...state,
        shared: action.payload,
      }
    default:
      return state
  }
}

export default report



// WEBPACK FOOTER //
// ./src/reducers/patient.reducer.ts